import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import cs from 'classnames'
import { REPORT_SEVERITY, useReportTypes } from '../../hooks/useReportTypes'

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        color: theme.primary,
        textTransform: 'uppercase',
        fontWeight: 'bold',
        border: `${theme.borderWidth}px dotted`,
        padding: 4,
        borderRadius: theme.borderRadius,
        marginRight: 4,
        whiteSpace: 'nowrap'
    },
    activeTrap: {
        borderColor: theme.active,
        color: theme.active
    },
    errorTrap: {
        borderColor: theme.error,
        color: theme.error
    },
    warningTrap: {
        borderColor: theme.warning,
        color: theme.warning
    },
    inactiveTrap: {
        borderColor: theme.secondary,
        color: theme.secondary
    }
}))

export default function Trap({
    className,
    trapNumber,
    trapStatus,
    lastReportType,
    trapText,
    trapCatch
}) {
    const classes = useStyles()
    const { severity } = useReportTypes(lastReportType)
    const isTrapWithCatchDetection = typeof trapCatch === 'number'

    const getTrapStyle = () => {
        if (
            !severity ||
            severity === REPORT_SEVERITY.inactive ||
            lastReportType === '5'
        ) {
            return classes.inactiveTrap
        }
        /**
         * Next condition is for the case when
         * catch is detected for a another trap
         * BUT the current one is false triggered
         */
        if (
            isTrapWithCatchDetection &&
            trapStatus &&
            lastReportType === '20' &&
            trapCatch === 0
        ) {
            return classes.warningTrap
        }
        /* ****************** */
        if (trapStatus && lastReportType !== '17') {
            return classes.errorTrap
        }
        if (
            (severity === REPORT_SEVERITY.warning &&
                !trapStatus &&
                lastReportType !== '17') ||
            (severity === REPORT_SEVERITY.warning &&
                trapStatus &&
                lastReportType === '17')
        ) {
            return classes.warningTrap
        }
        if (!trapStatus) {
            return classes.activeTrap
        }
        return classes.inactiveTrap
    }

    const trapClass = getTrapStyle()

    return (
        <div className={cs([classes.root, trapClass, className])}>
            {`${trapText}${
                trapNumber !== null && trapNumber !== undefined
                    ? ` ${trapNumber}`
                    : ''
            }`}
        </div>
    )
}
